import React, { useEffect } from 'react';
import { prop } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import { BACKBONE_APP_ROOT } from 'js/backbone/constants';
import { ManagedPopup } from 'js/components/common/Popup';
import { scrollService } from 'js/services/scroll.service';
import { ErrorMessage } from 'js/components/common/ErrorMessage';
import { WebContentInner } from 'js/components/system/WebContent';
import { useCombinedOnClose } from 'js/components/common/PopupManager';
import { useAuthSelector, useAppSelector, useUserSelector } from 'js/store/hooks';

import style from './LoginPopup.scss';

export const LoginPopup = ({ id, title, onClose, onLogin, controls }) => {
    const translate = useTranslations();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const loginWebContent = useAppSelector(prop('loginWebContent'));
    const closePopup = useCombinedOnClose(onClose, id);
    const isLoginInProcess = useAuthSelector(prop('isLoginInProcess'));

    useEffect(() => {
        if (!isLoggedIn || isLoginInProcess) {
            return;
        }

        if (onLogin) {
            onLogin();
        }

        closePopup();
        scrollService.scrollTo(0);
    }, [closePopup, isLoggedIn, onLogin, isLoginInProcess]);

    if (isLoggedIn) {
        return null;
    }

    return (
        <ManagedPopup
            id={id}
            title={title}
            classNames={style}
            controls={controls}
            onClose={closePopup}
            className={style.container}
            layerClassNames={{ layout: `${style.layout} ${loginWebContent ? '' : style.noLoginWc}` }}
        >
            {loginWebContent
                ? (
                    <WebContentInner
                        popupId={id}
                        content={loginWebContent}
                        className={`${style.loginWc} ${BACKBONE_APP_ROOT}`}
                        context={`loginWebContent::${id}`}
                    />
                ) : (
                    <ErrorMessage
                        className={style.error}
                        error={translate('playtech.mobile.system.loginPopup.noWebcontent')}
                    />
                )
            }
        </ManagedPopup>
    );
};
